import VideoPage from './video'

export default VideoPage
